import React from "react"

import { styled } from "@mui/material"

const StyledMenu = styled("nav", {
  shouldForwardProp: (prop) => prop !== "style",
})(({ theme, style = {} }) => {
  return {
    display: "flex",
    flexDirection: "column",
    margin: theme.spacing(2, 2, 2, 2.5),
    "& .menu-list-item": {
      display: "flex",
      padding: theme.spacing(1, 0.5)
    },
    "& ul": {
      listStyle: "none",
      padding: 0
    },
    ...style
  }
})

const Menu = (props) => {
  return (
    <StyledMenu className="menu menu-main" {...props}>
      <ul className="menu-list">
        {props.children}
      </ul>
    </StyledMenu>
  )
}

export default React.memo(Menu)